module.exports = __webpack_public_path__ + "static/media/bg25.c4de0e8f.png";